export const enChat = {
    translation : {
        'Responder a: ':"Reply to: ",
    }
};